import Vue from 'vue'
import App from './App.vue'
import store from './store'
// import Cookies from 'js-cookie'
import router from './router'
import prototype from './utils/prototype' // 挂载在原型上的方法
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/style/main.less'//全局CSS
import '@/style/element-variables.scss'


// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/icon.css'
// import '@/style/main.less'//全局CSS
// import '@/style/element-variables.scss'


import topFixed from './components/topFixed.vue';//引入步骤组件
import SearchView from './components/searchView.vue'
import ListView from './components/listView.vue'
import DialogView from './components/dialogView.vue'
import NewTopFixed from '@/components/newTopFixed.vue'
Vue.component('topFixed',topFixed)//全局注册组件
Vue.component('SearchView', SearchView)
Vue.component('ListView', ListView)
Vue.component('DialogView', DialogView)
Vue.component('NewTopFixed',NewTopFixed)
Vue.use(ElementUI);
Vue.use(prototype)

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

// 请求超时时限
axios.defaults.timeout = 180000
// 请求的间隙
axios.defaults.retryDelay = 1000

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
